import {AppModel} from '../models';
import {EventBus} from '../utils';

class MaxCampingSocket {
    connect(token) {
        if(token) {
            let endpoint = process.env.WS_ENDPOINT || 'ws://localhost:8000/{user}/';
            endpoint = endpoint.replace('{user}', AppModel.user.id);
            if(!this.socket) {
                console.debug(`[WebSocket] connecting to ${endpoint}`);
                this.socket = new WebSocket(`${endpoint}?token=${token}`);
                this.socket.onmessage = this.onMessage.bind(this);
                this.socket.onopen = this.onOpen.bind(this);
                if(this.socket.readyState === WebSocket.OPEN) {
                    this.socket.onopen(null);
                }
            }
        }
    }

    onOpen(event) {
        console.debug('[WebSocket] opened');
    }

    onMessage(event) {
        EventBus.$emit(EventBus.WS_MESSAGE_RECEIVED, JSON.parse(event.data));
    }
}

export default new MaxCampingSocket();



// WEBPACK FOOTER //
// ./src/api/WebSocket.js